import { render, staticRenderFns } from "./SignInExternal.vue?vue&type=template&id=850821a8"
import script from "./SignInExternal.vue?vue&type=script&lang=js"
export * from "./SignInExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports